import { render } from "./InsufficientPermissions.vue?vue&type=template&id=29199fa8"
import script from "./InsufficientPermissions.vue?vue&type=script&lang=js"
export * from "./InsufficientPermissions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__